import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MaxDurationShareButton from 'blocks/DownloadPage/components/MaxDurationShareButton';
import { LinkedInButton } from 'components/SocialButton';
import useLinkedinAuthenticator from 'hooks/useLinkedinAuthenticator';
import { videoDurationSecondsSelector } from 'redux/modules/download';
import { hideModal, pushModal } from 'redux/modules/modal';
import { createChainedFunction } from 'utils/functions';
import useOnDownloadPageAction from '../useOnDownloadPageAction';
import { MAX_VIDEO_DURATION_SEC } from './utils';

const LinkedinPostButton: React.FC = () => {
  const [shouldReauthenticate, setShouldReauthenticate] = useState<boolean>(
    false,
  );

  const videoDurationSec = useSelector(videoDurationSecondsSelector);

  const { onDownloadPageAction } = useOnDownloadPageAction();
  const dispatch = useDispatch();

  const handleError = useCallback(() => {
    setShouldReauthenticate(true);
    dispatch(hideModal());
  }, [dispatch]);

  const { authenticating, withAuthentication } = useLinkedinAuthenticator({
    force: shouldReauthenticate,
    onError: handleError,
  });

  const openSocialShareModal = useCallback(() => {
    dispatch(
      pushModal({
        name: 'SocialShare',
        params: {
          platform: 'linkedin',
        },
      }),
    );
  }, [dispatch]);

  return (
    <MaxDurationShareButton
      platform="linkedin"
      videoDurationSec={videoDurationSec}
      maxVideoDurationSec={MAX_VIDEO_DURATION_SEC}
    >
      <LinkedInButton
        size="small"
        params={withAuthentication}
        disabled={authenticating}
        onClick={createChainedFunction(
          () => onDownloadPageAction('linkedinShare'),
          withAuthentication(openSocialShareModal),
        )}
      />
    </MaxDurationShareButton>
  );
};

export default LinkedinPostButton;
